import { plaintextValidator, dropdownValidator } from '../fields';

export const invoiceRemindersConstraints = (needsDays) => ({
  triggerType: plaintextValidator({
    mandatory: true
  }),
  ...(needsDays
    ? {
        offsetValue: {
          numericality: true,
          presence: true
        }
      }
    : {})
});
